import {NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatInputModule, MatTableModule, MatToolbarModule } from '@angular/material';
import { MatPaginatorModule, MatSortModule } from '@angular/material';

@NgModule({
  imports: [CommonModule, MatToolbarModule, MatInputModule, MatPaginatorModule,MatSortModule, MatTableModule],
  exports: [CommonModule, MatToolbarModule, MatInputModule, MatPaginatorModule,MatSortModule, MatTableModule],
})
export class MaterialModule { }